export { FYMEntryPoints as default } from 'flows/forward-mail/pages/entry-point';
